/* eslint-disable */
import axios from 'axios'
import config from '../../config/britecore'
import {isFailed} from '../../shared_src/utils/api.utils'
import settings from '../../config/settings'

const localstoragePinKey = 'auth.pin.nonce'

const loginModule = {
  namespaced: true,
  state: {
    usernameToForceUpdatePassword: null, // i would rather have it here instead of sessionStorage/localStorage etc to avoid caching  and password update by mistake (for cases when passwords equal for different accounts)
    isAuthorized: false,
    pin_nonce: null,
    currentLoginScreenState: false,
    suppressLogInsuredAction: false, // this is flag for router.afterEach logInsuredAction requests
  },
  mutations: {
    setUsernameToForceUpdatePassword (state, usernameToForceUpdatePassword) {
      state.usernameToForceUpdatePassword = usernameToForceUpdatePassword
    },
    setSuppressLogInsuredAction (state, value) {
      state.suppressLogInsuredAction = value
    },
    updateCurrentLoginScreenState (state, isOpened) {
      let previousState = state.currentLoginScreenState
      if (previousState === isOpened) {
        console.warn(' - update login screen visibility will have no affect, currentLoginScreenState is already, ', isOpened)
        return
      }
      state.currentLoginScreenState = isOpened
    },
    removeTokenAndLoginTime (state) {
      localStorage.removeItem('token')
      localStorage.removeItem('loginTime')
      state.isAuthorized = false
    },
    updateToken (state, payload) {
      state.isAuthorized = Boolean(payload)
      if (payload) {
        localStorage.token = payload
      } else {
        localStorage.removeItem('token')
      }
    },
    updatePinNonce (state, payload) {
      state.pin_nonce = payload

      if (typeof payload !== 'undefined') {
        localStorage.setItem(localstoragePinKey, payload)
      } else {
        localStorage.removeItem(localstoragePinKey)

      }
    },
  },
  actions: {
    async loginMfa (context, payload) {
      context.commit('removeTokenAndLoginTime')
      let response = await axios.post(
        config.login_url,
        {
          username: payload.username,
          password: payload.password,
          company_id: settings.company_id,
          use_pin: payload.usePinNextTime,
        }
      )
      if (isFailed(response)) {
        return Promise.reject(response)
      }
      context.commit('updatePinNonce', response.data.pin_nonce)
      return response
    },
    async verifyMfa (context, payload) {
      let response = await axios.post(config.finish_mfa_login_url, payload)
      if (isFailed(response)) {
        return Promise.reject(response)
      }
      return response
    },
    sendMfaCode: function (context, payload) {
      return new Promise((resolve, reject) => {
        const url = config.send_mfa_code_url
        axios.post(url, payload).then((response) => {
          if (isFailed(response)) {
            reject(response)
            return
          }
          resolve()
        }).catch((e) => {
          reject(e)
        })
      })
    },
    async loginByPinMfa (context, payload) {
      // remove token/login_time before login attempt
      context.commit('removeTokenAndLoginTime')

      let response = await axios.post(
        config.login_by_pin,
          {
          pin: payload.pin,
          pin_nonce: payload.pin_nonce,
          company_id: settings.company_id,
      })
      if (isFailed(response)) {
        return Promise.reject(response)
      }
      context.commit('updatePinNonce', response.data.pin_nonce)
      return response
    },
    authByToken: function (context, payload) {
      return new Promise((resolve, reject) => {
        let data = {
          token: payload.token,
          company_id: settings.company_id,
        }
        let url = config.auth_by_token_url
        axios.post(url, data)
          .then((response) => {
            if (isFailed(response)) {
              reject(response)
              return
            }
            resolve()
          })
          .catch((e) => {
            reject(e)
          })
      })
    },
    async init (context, authDict) {
      context.commit('updateToken', localStorage.token)
      let nonce = localStorage.getItem('auth.pin.nonce')
      if (nonce) {
        context.commit('updatePinNonce', nonce)
      }
      if (authDict) {
        context.commit('removeTokenAndLoginTime')
        try {
          await context.dispatch('loginMfa', {...authDict, usePinNextTime: false})
          context.commit('setSuppressLogInsuredAction', false)
        } catch (err) {
          console.warn('QueryParam based login failed!')
          context.commit('setSuppressLogInsuredAction', false)
        }
      }
      if (context.state.isAuthorized) {
        try {
          await axios.post(config.check_token_url, { //recheck token
            token: localStorage.token,
          })
        } catch (err) {
          context.commit('removeTokenAndLoginTime')
        }
      }
    },
    loginScreenWillShow (context, payload) {
      context.commit('updateCurrentLoginScreenState', true)
    },
    loginScreenDidHide (context, payload) {
      context.commit('updateCurrentLoginScreenState', false)
    },
    clearPinNonce (context, payload) {
      context.commit('updatePinNonce')

    },
  },
  getters: {},
}

export default loginModule
